import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import Button from "../../../UI/button/Button";
import { postCourierBalance } from "../../../../MyApi/curior";

const AddBalanceModal = ({ isOpen, toggle, targetId, targetType = "courier" }) => {
  const queryClient = useQueryClient();

  const [formData, setFormData] = useState({
    direction: "credit",
    amount: "",
    reason: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const { mutate, isLoading } = useMutation({
    mutationKey: ["postCourierBalance"],
    mutationFn: (postData) => postCourierBalance(postData),

    onSuccess: () => {
      toast.success("تم تحديث الرصيد بنجاح");
      queryClient.invalidateQueries("getCourierTransactions");
      setFormData({ direction: "credit", amount: "", reason: "" });
      toggle();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message);
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    const postData = {
      target_type: targetType,
      target_id: targetId,
      direction: formData.direction,
      amount: formData.amount,
      reason: formData.reason,
    };

    mutate(postData);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered className="add">
      <ModalHeader toggle={toggle}>إضافة و سحب رصيد</ModalHeader>

      <Form onSubmit={handleSubmit}>
        <ModalBody>
          <div className="row g-3">
            <div className="col-12">
              <FormGroup>
                <Label>النوع</Label>
                <Input
                  type="select"
                  name="direction"
                  value={formData.direction}
                  onChange={handleChange}
                >
                  <option value="credit">إضافة (Credit)</option>
                  <option value="debit">خصم (Debit)</option>
                </Input>
              </FormGroup>
            </div>

            <div className="col-12">
              <FormGroup>
                <Label>المبلغ</Label>
                <Input
                  type="number"
                  name="amount"
                  value={formData.amount}
                  onChange={handleChange}
                  min={1}
                  required
                />
              </FormGroup>
            </div>

            <div className="col-12">
              <FormGroup>
                <Label>السبب</Label>
                <Input
                  type="textarea"
                  name="reason"
                  value={formData.reason}
                  onChange={handleChange}
                  required
                />
              </FormGroup>
            </div>
          </div>
        </ModalBody>

        <ModalFooter className="d-flex align-items-center flex-nowrap">
          <button
            type="button"
            className="btn btn-white"
            onClick={toggle}
            disabled={isLoading}
          >
            إلغاء
          </button>

          <Button
            className="btn-primary"
            isLoading={isLoading}
            disabled={isLoading}
            label="إضافة"
            onClick={handleSubmit}
          />
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddBalanceModal;